import styled from 'styled-components';

export const Container = styled('div')`
  flex: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-self: center;
  align-items: flex-start;
  margin-bottom: 2em;
  flex-direction: column;
`;

export const ConfigContainer = styled('div')`
  display: flex;
  width: 100%;
  overflow: scroll;
  flex-direction: row;
  min-height: 200px;
  flex-wrap: wrap;
  flex: 1;
`;

export const BasicConfigContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
`;

export const BasicConfigChild = styled.div`
  width: 100%;
  display: flex;
  gap: 3rem;
`;

export const ButtonGroupContainer = styled.div`
  flex-basis: 10rem;
  margin-top: 1rem;
`;

export const SelectedButtonGroupContent = styled.div`
  flex: 1;
  margin: 0 1rem;
`;
